<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  icon: { type: String, default: 'i-lucide-circle' },
  tone: { type: String, default: 'slate' }, // slate | blue | green | red | amber | indigo
  hint: { type: String, default: '' }, // nota "estado actual" (oculta en móvil para compactar)
  clickable: { type: Boolean, default: false },
  // La card cuyo filtro está aplicado al tablero se ve seleccionada
  // (borde + fondo de marca); re-clickearla lo quita (toggle).
  active: { type: Boolean, default: false },
});
defineEmits(['select']);

const TONES = {
  slate: 'text-n-slate-11',
  blue: 'text-n-blue-11',
  green: 'text-n-teal-11',
  red: 'text-n-ruby-11',
  amber: 'text-n-amber-11',
  indigo: 'text-n-brand',
};
</script>

<template>
  <!-- Móvil: chip compacto (no encoge → la fila scrollea). Desktop: tarjeta que crece. -->
  <!-- Borde/fondo van en :class (no estáticos): dos utilidades del mismo
       property compiten por orden de stylesheet, no por orden del atributo. -->
  <button
    type="button"
    :disabled="!clickable"
    class="flex flex-shrink-0 flex-col gap-0.5 rounded-lg border p-2.5 text-left transition min-w-[5.5rem] md:min-w-[9rem] md:flex-1 md:flex-shrink md:gap-1 md:p-3"
    :class="[
      active
        ? 'border-n-brand bg-n-alpha-2 shadow-sm'
        : 'border-n-weak bg-n-solid-1',
      clickable
        ? 'cursor-pointer hover:shadow-sm ' +
          (active ? '' : 'hover:border-n-strong')
        : 'cursor-default',
    ]"
    :aria-pressed="active || undefined"
    @click="clickable && $emit('select')"
  >
    <div
      class="flex items-center w-full gap-1 text-xs font-medium text-n-slate-11 md:gap-1.5"
    >
      <span :class="[icon, TONES[tone]]" class="text-sm" />
      <span class="truncate">{{ label }}</span>
      <!-- Affordance de "re-click quita": la ✕ solo aparece en la card activa. -->
      <span
        v-if="active"
        class="flex-shrink-0 ml-auto i-lucide-x size-3 text-n-slate-10"
        aria-hidden="true"
      />
    </div>
    <span
      class="text-lg font-semibold leading-tight tabular-nums md:text-xl"
      :class="TONES[tone]"
      >{{ value }}</span
    >
    <span v-if="hint" class="hidden text-xs text-n-slate-10 md:block">{{
      hint
    }}</span>
  </button>
</template>
